export type IncidenceRequestApiStatus =
  | 'BORRADOR'
  | 'EN_REVISION_SUPERVISOR'
  | 'EN_REVISION_RH'
  | 'WRONG_SUPERVISOR'
  | 'AUTORIZADA'
  | 'RECHAZADA';

export type IncidenceRequestRhVisibleApiStatus =
  | 'APPROVED_BY_SUPERVISOR'
  | 'SUPERVISOR_INCORRECT';

export type IncidenceRequestStatus =
  | 'draft'
  | 'review_supervisor'
  | 'review_hr'
  | 'wrong_supervisor'
  | 'approved'
  | 'rejected';

export type IncidenceRequestRhVisibleStatus =
  | 'approved_by_supervisor'
  | 'supervisor_incorrect';

export type IncidenceRequestCategory = {
  _id: string;
  desc: string;
  abbr: string;
  solicitable?: boolean;
};

export type IncidenceRequestAttachment = {
  name: string;
  url: string;
  s3Key?: string;
  mimeType?: string;
  size?: number;
};

export type IncidenceRequestRecord = {
  _id: string;
  folio: string;
  reason: string;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
  submittedAt?: string;
  approvedAt?: string;
  authorizedAt?: string;
  rejectedAt?: string;
  rejectionReason?: string;
  status: IncidenceRequestApiStatus;
  rhVisibleStatus?: IncidenceRequestRhVisibleApiStatus;
  attachments?: IncidenceRequestAttachment[];
  incidenceCategory: IncidenceRequestCategory;
  requester?: IncidenceRequestActor;
  currentApprover?: IncidenceRequestActor;
};

export type IncidenceRequestActor = {
  _id: string;
  idEmployee: string;
  name: string;
  lastName: string;
  email: string;
  role?: string;
};

export type IncidenceRequestStatusHistoryEntry = {
  fromStatus: IncidenceRequestApiStatus;
  toStatus: IncidenceRequestApiStatus;
  action: string;
  performedAt: string;
  comment?: string;
  performedBy?: IncidenceRequestActor;
};

export type IncidenceRequestHistoryRecord = Pick<
  IncidenceRequestRecord,
  '_id' | 'folio' | 'startDate' | 'endDate' | 'status' | 'incidenceCategory'
>;

export type IncidenceRequestDetailRecord = IncidenceRequestRecord & {
  requester: IncidenceRequestActor;
  currentApprover?: IncidenceRequestActor;
  approvedBy?: IncidenceRequestActor;
  rejectedBy?: IncidenceRequestActor;
  authorizedBy?: IncidenceRequestActor;
  statusHistory: IncidenceRequestStatusHistoryEntry[];
  history: IncidenceRequestHistoryRecord[];
};

export type IncidenceRequestsPagination = {
  page: number;
  limit: number;
  total: number;
  pages: number;
};

export type IncidenceRequestsListResponse = {
  data: IncidenceRequestRecord[];
  pagination: IncidenceRequestsPagination;
};

export type IncidenceRequestsPendingSummaryResponse = {
  data: {
    hasPending: boolean;
  };
};

export type CreateIncidenceRequestPayload = {
  incidenceCategory: string;
  reason: string;
  startDate: string;
  endDate: string;
  attachments?: IncidenceRequestAttachment[];
};

export type UpdateIncidenceRequestPayload =
  Partial<CreateIncidenceRequestPayload> & {
    submit?: boolean;
  };

export type PresignIncidenceRequestAttachmentPayload = {
  fileName: string;
  mimeType: string;
};

export type PresignIncidenceRequestAttachmentResponse = {
  uploadUrl: string;
  expiresIn: number;
  attachment: IncidenceRequestAttachment;
};

export type PresignIncidenceRequestAttachmentDownloadPayload = {
  s3Key: string;
};

export type PresignIncidenceRequestAttachmentDownloadResponse = {
  downloadUrl: string;
  expiresIn: number;
  attachment: IncidenceRequestAttachment;
};

export type UpdateIncidenceRequestStatusPayload = {
  status: IncidenceRequestApiStatus;
  rejectionReason?: string;
};

export type ReassignIncidenceRequestSupervisorPayload = {
  supervisorId: string;
};

export const incidenceRequestRhVisibleStatusMap: Record<
  IncidenceRequestRhVisibleApiStatus,
  IncidenceRequestRhVisibleStatus
> = {
  APPROVED_BY_SUPERVISOR: 'approved_by_supervisor',
  SUPERVISOR_INCORRECT: 'supervisor_incorrect',
};

export const incidenceRequestRhVisibleApiStatusMap: Record<
  IncidenceRequestRhVisibleStatus,
  IncidenceRequestRhVisibleApiStatus
> = {
  approved_by_supervisor: 'APPROVED_BY_SUPERVISOR',
  supervisor_incorrect: 'SUPERVISOR_INCORRECT',
};

export const incidenceRequestStatusMap: Record<
  IncidenceRequestApiStatus,
  IncidenceRequestStatus
> = {
  BORRADOR: 'draft',
  EN_REVISION_SUPERVISOR: 'review_supervisor',
  EN_REVISION_RH: 'review_hr',
  WRONG_SUPERVISOR: 'wrong_supervisor',
  AUTORIZADA: 'approved',
  RECHAZADA: 'rejected',
};

export const incidenceRequestApiStatusMap: Record<
  IncidenceRequestStatus,
  IncidenceRequestApiStatus
> = {
  draft: 'BORRADOR',
  review_supervisor: 'EN_REVISION_SUPERVISOR',
  review_hr: 'EN_REVISION_RH',
  wrong_supervisor: 'WRONG_SUPERVISOR',
  approved: 'AUTORIZADA',
  rejected: 'RECHAZADA',
};
